import { Portal } from 'bringg-web/components';
import { ReserveCapacity } from 'bringg-web/features/reserve-capacity';

const ReserveCapacityPortal = () => {
	return <Portal element={<ReserveCapacity />} nodeId="reserve-capacity-page" />;
};

export default ReserveCapacityPortal;
